import { mutationOptions } from "@/common/mutations/mutationOptions";
import { RegisterPushNotificationsDeviceContract } from "./RegisterPushNotificationsDeviceContract";
import { getCommonFetchHeaders } from "@/common/getCommonFetchHeaders";
import { HttpStatus } from "@/common/contracts";
import type { z } from "zod";
import type { QueryClient } from "@tanstack/react-query";

export function registerPushNotificationsDeviceMutationOptions(
	queryClient: QueryClient,
) {
	return mutationOptions({
		mutationKey: [RegisterPushNotificationsDeviceContract.path],
		mutationFn: async (input: {
			params: z.infer<typeof RegisterPushNotificationsDeviceContract.params>;
			search: z.infer<typeof RegisterPushNotificationsDeviceContract.search>;
			body: z.infer<typeof RegisterPushNotificationsDeviceContract.body>;
		}) => {
			return fetch(
				`${import.meta.env.VITE_API_URL}/api${RegisterPushNotificationsDeviceContract.serializePath(
					input.params,
					input.search,
				)}`,
				{
					method: RegisterPushNotificationsDeviceContract.method,
					headers: {
						...(await getCommonFetchHeaders()),
						"Content-Type": "application/json",
					},
					body: JSON.stringify(input.body),
				},
			).then(async (res) => {
				const result = RegisterPushNotificationsDeviceContract.response.parse({
					status: res.status,
					body: await res.json(),
				});
				if (result.status === HttpStatus.Success) {
					return result.body;
				}
				throw new Error(result.body.message);
			});
		},
	});
}
